import IndexContent from "../../../../src/pages/use-cases/page-content/content-publishing/digital-content-publishing.md";
import * as React from 'react';
export default {
  IndexContent,
  React
};